<li class="checkbox-icon schedule-checkbox-inline">
  <input
    id="{{ id }}-input"
    name="{{ id }}-input"
    type="checkbox"
    [checked]="selected"
    (change)="selectedChange.emit($event.target.checked)"
    [disabled]="isDisabled"
    [attr.checked]="selected"
    [attr.data-test]="id + '-setting'"
  />
  <label
    for="{{ id }}-input"
    class="setting inline-icon icon-editor-checkbox-light-unchecked"
    [class.disabled]="isDisabled"
    capraTooltip
    [tooltipContent]="'This attachment has been disabled for your Workspace'"
    [tooltipIsDisabled]="!disabledByWorkspaceSetting"
    [tooltipPlacement]="'right'"
    [tooltipInteractive]="false"
    [attr.data-test]="id + '-label'"
  >
    <ng-content></ng-content>
  </label>
</li>
